<div class="container mt-3">
  <h2 
  class="mb-4 notification-title"
  [ngClass]="{ 'dark-text': themeService.isDark(), 'light-text': !themeService.isDark() }">
  Notifications
</h2>

<ul class="list-group">
  <li
    class="list-group-item d-flex justify-content-between align-items-start flex-column flex-md-row gap-2 shadow-sm mb-2 rounded p-3 border-0"
    *ngFor="let notif of notifications"
    [ngClass]="{
      'notif-light': !themeService.isDark(),
      'notif-dark': themeService.isDark()
    }"
  >
  
    <div class="notif-text">
      <div class="notif-meta">
        <i class="material-symbols-outlined icon-notif">notifications</i>
        <span class="ms-1">{{ notif.creationTime }}</span>
      </div>
      <div class="notif-message">
        {{ notif.message }}
      </div>
    </div>

    <button (click)="deleteNotif(notif.id)"
      class="daxa-badge d-inline-flex align-items-center justify-content-center rounded-circle delete-btn">
      <i class="material-symbols-outlined">delete</i>
    </button>
  </li>
</ul>

</div>
